import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { urlGetVeiculosEmRotaStats, urlGetEntregasVeiculo } from '../../routes/dashboard.routes'

const PainelVeiculosEmRotaHttp = {
  async getVeiculosEmRotaStats(tpId, pInicial, pFinal) {
    try {
      const url = urlGetVeiculosEmRotaStats(tpId, pInicial, pFinal)
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },

  async getEntregasVeiculo(fleetId, tpId) {
    try {
      const url = urlGetEntregasVeiculo(fleetId, tpId)
      const response = await authHttp().get(url)
      return response.data
    } catch (e) {
      throw errorHandler(e)
    }
  },
}

export default PainelVeiculosEmRotaHttp
